import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import { useTranslation } from '../../locale/useTranslation';
import * as API from '../../framework/API/api';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { toast } from 'react-toastify';
import { ArrayCell } from '../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { DateOnlyCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { DropDownCell } from './ContractCommandCell';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { FILEURL } from '../../framework/constant/constant';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';

const AmortizationRuleReport = ({ item = {}, onClose }) => {

    const lang = useTranslation();
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        loadData();
    }, [item]);

    const loadData = async () => {
        let payload = {
            ContractSID: item?.SID,
            AmortizationRule: item?.AmortizationRule && Object.keys(item?.AmortizationRule).length > 0 ? { _id: item?.AmortizationRule?._id, Description: item?.AmortizationRule?.Description, RuleText: item?.AmortizationRule?.RuleText } : {},
            isExport: false
        }
        let res = await API.getAmortizationRule(payload);
        console.log(res);
        if (res.success) {
            setGridData(res.data);
        } else {
            setGridData([]);
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const downloadExcel = async () => {

        if (gridData.length == 0) {
            toast.error(lang.no_record_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        let payload = {
            ContractSID: item?.SID,
            AmortizationRule: item?.AmortizationRule && Object.keys(item?.AmortizationRule).length > 0 ? { _id: item?.AmortizationRule?._id, Description: item?.AmortizationRule?.Description, RuleText: item?.AmortizationRule?.RuleText } : {},
            isExport: true
        }
        let res = await API.getAmortizationRule(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
            toast.success(`${lang.successfully_download_success_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    return (
        <BossDialog title={lang.amortization_rule_report_dialog_header} onClose={onClose} width='60%'>
            <div className='mb-2'>
                <RoundButton icon='download' onClick={downloadExcel} title={lang.download_button_tooltip} />
            </div>
            <Grid resizable data={gridData} style={{ height: '400px' }}>
                <GridColumn field="ContractTitle.Title" title={lang.title_column} width={'150px'} />
                <GridColumn field="ContractTitle.AssetId" title={lang.assetId_column} width={'150px'} />
                <GridColumn field="MediaCategory.Description" title={lang.media_category_column} width={'150px'} />
                <GridColumn field="Amount" width={'150px'} title={lang.amount_column} />
                <GridColumn field="AmortizationRule" width={'150px'} title={lang.amortization_rule_column} />
                <GridColumn field="AmortizationValue" width={'150px'} title={lang.amortization_value_column} />
                <GridColumn field="Channel" format="FullChannelName" cell={ArrayCell} width={'150px'} title={lang.channel_column} />
                <GridColumn field="Region" format="Description" cell={ArrayCell} width={'150px'} title={lang.region_column} />
                <GridColumn field="RevShare" width={'150px'} title={lang.revenue_share_column} />
                <GridColumn field="Currency.Description" width={'150px'} title={lang.currency_column} />
                <GridColumn field="PublishStartDate" title={lang.start_date_column} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="PublishEndDate" title={lang.end_date_column} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="Exhibitions" title={lang.exhibition_column} width={'150px'} />
                <GridColumn field="Repeats" title={lang.repeat_column} width={'125px'} />
                <GridColumn field="PlayTimeNumber" title={lang.play_time_number_column} width={'125px'} />
                <GridColumn field="PlayTime" title={lang.playTime_column} cell={DropDownCell} width={'150px'} />
                <GridColumn field="IsUnlimited" title={lang.is_unlimited_column} width={'105px'} cell={CheckboxCell} />
                <GridColumn field="IsExclusive" title={lang.is_exclusive_column} width={'105px'} cell={CheckboxCell} />
                <GridColumn field="ExclusiveStartDate" title={lang.exclusive_start_date_column} cell={DateOnlyCell} width={'150px'} />
                <GridColumn field="ExclusiveEndDate" title={lang.exclusive_end_date_column} cell={DateOnlyCell} width={'150px'} />
            </Grid>
        </BossDialog>
    )
}

export default AmortizationRuleReport